export interface VisibleTimelineMeasuresDetails {
	firstVisibleMeasure: number;
	lastVisibleMeasure: number;
}

// Custom event to notify subscribers when the visible timeline measures change
export class VisibleTimelineMeasuresChangedEvent {
	private static subscribers: Set<(detail: VisibleTimelineMeasuresDetails) => void> = new Set();

	// Subscribe to the event
	static subscribe(callback: (detail: VisibleTimelineMeasuresDetails) => void): void {
		VisibleTimelineMeasuresChangedEvent.subscribers.add(callback);
	}

	// Unsubscribe from the event
	static unsubscribe(callback: (detail: VisibleTimelineMeasuresDetails) => void): void {
		VisibleTimelineMeasuresChangedEvent.subscribers.delete(callback);
	}

	// Fire the event to notify all subscribers
	static fire(detail: VisibleTimelineMeasuresDetails): void {
		VisibleTimelineMeasuresChangedEvent.subscribers.forEach(callback => callback(detail));
	}
}

// Custom event to notify subscribers when sections have been dropped onto the timeline
export class TimelineSectionDropCompletedEvent {
	private static subscribers: Set<() => void> = new Set();

	// Subscribe to the event
	static subscribe(callback: () => void): void {
		TimelineSectionDropCompletedEvent.subscribers.add(callback);
	}

	// Unsubscribe from the event
	static unsubscribe(callback: () => void): void {
		TimelineSectionDropCompletedEvent.subscribers.delete(callback);
	}

	// Fire the event to notify all subscribers
	static fire(): void {
		TimelineSectionDropCompletedEvent.subscribers.forEach(callback => callback());
	}
}